// 반품 관리 섹션 URL (2026-08-12 KST 추가)
const orderReturnsSection = "/order-returns";

export const orderReturnsPath = orderReturnsSection;
